"use strict";

var PropTypes = require("prop-types");

var AccountActions = require("./AccountActions");
var AccountConstants = require("./AccountConstants");
var AccountFormHelper = require("./AccountFormHelper");
var AccountStore = require("./AccountStore");

var SimpleDropdownFromWizard = require("../commonComponents/SimpleDropdownFromWizard");

class AccountEmailTypeSelector extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			disabled: false,
			selectedEmailType: props.initialValue || ""
		};

		this._onChange = this._onChange.bind(this);
	}

	handleEmailTypeSelected(event) {
		if (!event || !event.currentTarget) {
			return;
		}

		var selectedEmailType = event.currentTarget.value;
		var formParentId = AccountFormHelper.getParentFormId(this);

		AccountActions.setSelectedEmailType(formParentId, selectedEmailType);
	}

	_onChange() {
		if (!this._isMounted) {
			return;
		}

		var $formParent = AccountFormHelper.getParentForm(this);
		var formParentId = AccountFormHelper.getParentFormId(this);

		var parentFormIdForUpdateAllowed = formParentId;
		if ($formParent.length > 0) {
			// updateAllowed applies to this selector when inside the createAccountForm or when inside the eventRegistration component (could be within a createAccountForm or spouseInformation)
			var $parentFormForUpdateAllowed = $formParent.is("[data-component='createAccountForm']") ? $formParent : $formParent.closest("[data-component='eventRegistration']").find("[data-component='createAccountForm']");
			parentFormIdForUpdateAllowed = AccountFormHelper.getParentFormIdFromForm($parentFormForUpdateAllowed);
		}

		this.setState({
			disabled: formParentId ? AccountActions.getIsFormInputDisabled(parentFormIdForUpdateAllowed || formParentId) : false,
			selectedEmailType: AccountActions.getSelectedEmailType(formParentId) || ""
		});
	}

	componentDidMount() {
		this._isMounted = true;

		var $formParent = AccountFormHelper.getParentForm(this);
		var formParentId = AccountFormHelper.getParentFormIdFromForm($formParent);
		var updateAllowed = true;

		if ($formParent.length > 0) {
			// updateAllowed applies to this selector when inside the createAccountForm or when inside the eventRegistration component (could be within a createAccountForm or spouseInformation)
			var $parentFormForUpdateAllowed = $formParent.is("[data-component='createAccountForm']") ? $formParent : $formParent.closest("[data-component='eventRegistration']").find("[data-component='createAccountForm']");
			updateAllowed = !$parentFormForUpdateAllowed.length || $parentFormForUpdateAllowed.is("[data-update-allowed]");
		}

		AccountActions.setSelectedEmailType(formParentId, this.state.selectedEmailType);
		AccountStore.addSpecificListener(AccountConstants.SET_SELECTED_EMAIL_TYPE, this._onChange);
		AccountStore.addChangeListener(this._onChange);
		AccountActions.toggleInputStatus(formParentId, /*disabled*/ !updateAllowed);
	}

	componentWillUnmount() {
		AccountStore.removeChangeListener(this._onChange);
		AccountStore.removeSpecificListener(AccountConstants.SET_SELECTED_EMAIL_TYPE, this._onChange);

		if (this.props.isDesignMode) {
			var $formParent = AccountFormHelper.getParentForm(this);
			var formParentId = AccountFormHelper.getParentFormIdFromForm($formParent);
			var updateAllowed = true;

			if ($formParent.length > 0) {
				updateAllowed = $formParent.is("[data-update-allowed]");
			}

			AccountActions.setSelectedEmailType(formParentId, null);
			AccountActions.toggleInputStatus(formParentId, /*disabled*/ !updateAllowed);
		}

		this._isMounted = false;
	}

	render() {
		return (
			<SimpleDropdownFromWizard
				{...this.props}
				config={this.props.emailTypeConfig}
				configKey="availableEmailTypes"
				disabled={this.state.disabled}
				initialValue={this.state.selectedEmailType}
				optionsClassName="availableEmailType"
				reactComponentName="AccountEmailTypeSelector"
				selectClassName="account-email-type-selector"
				selectNameAttribute="email.type"
				thisArg={this}
				wizard={AccountStore.get("wizardDefaultEmailTypes")}
				wizardValuesKey="allowedEmailTypes"
			/>
		);
	}
}

AccountEmailTypeSelector.propTypes = {
	isDesignMode: PropTypes.bool,
	emailTypeConfig: PropTypes.object,
	required: PropTypes.bool,
	theme: PropTypes.string,
	context: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	childClass: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string,
	reactComponentCategory: PropTypes.string
};

module.exports = AccountEmailTypeSelector;
